import { buttonModes, components, permissionPresets, services, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import fileDialog from '@/components/file/dialog'
import fileDrop from '@/components/file/drop'
import fileFilter from '@/components/file/filter'
import fileItems from '@/components/file/items'
import info from '@/components/info'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'

function renderLoadingArea(h) {
  return h(
    'div',
    {
      class: {
        'files__upload-area': true,
        'files__upload-area--active': this.showLoadingArea
      },
      domProps: { innerHTML: this.getTranslate('files.drop') },
      on: {
        dragleave: this.drop,
        drop: this.drop
      }
    }
  )
}
function renderFileDrop(h, trigger = true, type = 'button') {
  if (trigger) {
    if (this.checkPermissions(`advanced.${services.storage}.upload`, permissionPresets.meUp)) {
      return h(
        fileDrop,
        {
          props: {
            name: this.name,
            isPublic: this.isPublic,
            maxFileSize: this.maxFileSize,
            accepted: this.types,
            loading: this.loading,
            disabled: this.loading,
            type
          }
        },
        [ renderLoadingArea.call(this, h) ]
      )
    }
  }
}

function renderPreloader(h, absolute = false) {
  if (this.restData[services.storage].find.state === states.loading) {
    return h(
      'div',
      {
        class: {
          'preloader__holder pa-5': true,
          'preloader__holder--absolute': absolute
        }
      },
      [ h(preloader) ]
    )
  }
}

function renderPagination(h) {
  return h(
    'div',
    {
      class: 'files__pagination'
    },
    [
      h(
        pagination,
        {
          props: {
            value: this.restData[services.storage].find.pagination,
            service: services.storage,
            selectRows: false
          },
          on: {
            input: event => {
              this.restData[services.storage].find.pagination = event
            }
          }
        }
      ),

      h(
        buttonRefresh,
        {
          props: {
            state: this.restData[services.storage].find.state,
            shortClickMethod: () => {
              return this.rest[services.storage].find()
            },
            longClickMethod: () => {
              return this.rest[services.storage].find({}, { noCache: true })
            },
            disabled: this.loading
          }
        }
      )
    ]
  )
}

function renderFilter(h) {
  return h(
    fileFilter,
    {
      props: {
        value: this.restData[services.storage].find.filter,
        types: this.types
      },
      on: {
        input: event => {
          this.restData[services.storage].find.filter = event
        }
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: 'files__actions'
    },
    [ renderFileDrop.call(this, h) ]
  )
}
function renderHeaderContent(h) {
  return h(
    'div',
    {
      class: 'files__header-content'
    },
    [
      renderFilter.call(this, h),
      renderActions.call(this, h)
    ]
  )
}
function renderHeader(h) {
  let slot
  if (this.embedded && !this.viewport.breakpoint.xs) {
    slot = 'header'
  }

  return h(
    'div',
    {
      class: {
        files__header: true,
        'files__header--embedded': this.embedded
      },
      slot
    },
    [
      renderHeaderContent.call(this, h),
      renderPagination.call(this, h, true)
    ]
  )
}

function renderItems(h) {
  return h(
    fileItems,
    {
      props: {
        items: this.restData[services.storage].find.data,
        order: this.restData[services.storage].find.order,
        currentChosenFileId: this.currentChosenFileId,
        readonly: this.readonly,
        embedded: this.embedded
      },
      on: {
        input: event => {
          this.$emit('input', event)
        },
        order: event => {
          this.restData[services.storage].find.order = event
        },
        dialog: event => {
          if (event.close) {
            this.googleFileURL = undefined
            this.currentEditFile = undefined
            this.editDialogType = undefined
            this.showEditDialog = false

            return
          }
          this.googleFileURL = event.googleFileURL
          this.currentEditFile = event.currentEditFile
          this.editDialogType = event.editDialogType
          this.showEditDialog = true
        }
      },
      key: 'file-manager-content'
    }
  )
}
function renderContent(h) {
  if (this.restData[services.storage].find.pagination.total) {
    return renderItems.call(this, h)
  }

  return h(components.empty)
}

function renderBodyWithDrag(h) {
  return h(
    'div',
    {
      class: {
        files__body: true,
        'files__body--loading': this.state === states.loading
      },
      on: {
        dragenter: event => {
          event.preventDefault()
          event.stopPropagation()
          this.showLoadingArea = true
        }
      }
    },
    [
      renderContent.call(this, h),
      renderPreloader.call(this, h, true),
      renderFileDrop.call(this, h, true, 'drop')
    ]
  )
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${services.storage}.hints.expire`)
      }
    }
  )
}
function renderCloseButton(h) {
  if (this.embedded) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.close'),
          mode: buttonModes.flat
        },
        on: {
          click: () => {
            this.$emit('show', false)
          }
        }
      }
    )
  }
}
function renderFooter(h) {
  let slot
  if (this.embedded) {
    slot = 'footer'
  }

  return h(
    'div',
    {
      class: {
        files__footer: true,
        'files__footer--embedded': this.embedded
      },
      slot
    },
    [
      renderInfo.call(this, h),
      renderCloseButton.call(this, h)
    ]
  )
}

function renderFileDialog(h) {
  return h(
    fileDialog,
    {
      props: {
        value: this.currentEditFile,
        googleFileURL: this.googleFileURL,
        show: this.showEditDialog,
        type: this.editDialogType
      },
      on: {
        show: event => {
          this.showEditDialog = event
        },
        input: event => {
          this.currentEditFile = event
        }
      }
    }
  )
}

export default function(h) {
  let rounded = true
  if (this.embedded) {
    rounded = this.viewport.breakpoint.mdUp
  }

  let maxWidth
  if (this.embedded) {
    maxWidth = '100%'
    if (this.viewport.breakpoint.mdUp) {
      maxWidth = 1000
    }
  }

  return h(
    this.component,
    {
      props: {
        value: this.show,
        rounded,
        outline: !this.embedded,
        maxWidth,
        closeOnClick: this.embedded && !this.loading,
        closeOnEsc: this.embedded && !this.loading
      },
      on: {
        input: event => {
          this.$emit('show', event)
        }
      }
    },
    [
      renderHeader.call(this, h),
      renderBodyWithDrag.call(this, h),
      renderFooter.call(this, h),
      renderFileDialog.call(this, h)
    ]
  )
}

